/**
 * SponsorBlock's own vocabulary — shared by the Settings page (the category grid) and the Watch
 * page (bar stripes, toasts, chapter badges), which is why it is a section rather than a child of
 * either screen's. The names follow the project's upstream wording where it is self-explanatory
 * and plainer words where it is not ("music: non-music section" would be a riddle in a badge).
 */
export const sponsorBlock = {
  category: {
    sponsor: 'Sponsor',
    selfpromo: 'Self-promotion',
    interaction: 'Interaction reminder',
    intro: 'Intro',
    outro: 'Outro',
    preview: 'Preview',
    music_offtopic: 'Non-music',
    filler: 'Filler',
  },
} as const;
